package com.klantenstop.web.pages.authentication.resetPassword

import com.klantenstop.web.utils.MVI

interface ResetPasswordContract : MVI<ResetPasswordContract.State, ResetPasswordContract.Intent, ResetPasswordContract.Effect> {
    data class State(
        val token: String = "",
        val password: String = "",
        val passwordConfirmation: String = "",
        val isLoading: Boolean = false,
        val hasAttemptedReset: Boolean = false
    )

    sealed class Intent {
        data object SubmitResetPassword : Intent()
        data class UpdatePassword(val value: String) : Intent()
        data class UpdatePasswordConfirmation(val value: String) : Intent()
    }

    sealed class Effect {
        data object NavigateToLogin : Effect()
    }
}

